module.exports = __webpack_public_path__ + "img/data-analytic-screen.151bf147.svg";